/**
 * TEXT, TEXTPRICE (texte + price), PRICE
 */
 const priceType = {
    PRICE: 'price',
    TEXTPRICE: 'textPrice',
    TEXT: 'text'
  }
export default priceType;
